class WorkPlanModalSrv {

	constructor ($mdDialog, $cookies, WorkPlanSrv) {
		let endPlanning = () => {
			return $mdDialog.show({
				controller         : 'EndPlanningModalCtrl',
				template           : require('./partials/modals/endPlanningModal.html'),
				clickOutsideToClose: false,
			})
		}

		function addActivity (option = 'standard') {
			switch (option) {

			case 'standard':
				return $mdDialog.show({
					controller         : 'AddActivityCtrl',
					template           : require('./partials/review/modals/addActivity.html'),
					clickOutsideToClose: false,
					controllerAs       : 'addActivity',
				})
			case 'custom':
				return $mdDialog.show({
					template           : '<add-custom></add-custom>',
					clickOutsideToClose: false,
				})
			
			}
		}

		let registerExecution = () => {
			return $mdDialog.show({
				controller         : 'RegisterExecutionCtrl',
				template           : require('./partials/review/modals/registerExecution.html'),
				clickOutsideToClose: false,
				controllerAs       : 'regExecution',
			})
		}

		let editChildrenExecution = (activity) => {
			return $mdDialog.show({
				controller         : 'EditChildrenExecutionCtrl',
				template           : require('./partials/review/modals/editChildrenExecution.html'),
				clickOutsideToClose: false,
				controllerAs       : 'editChildrenExecutionVm',
				locals             : { activity: activity },
			})
		}

		let executionEntries = () => {
			return $mdDialog.show({
				controller         : 'ExecutionEntriesCtrl',
				template           : require('./partials/review/modals/executionEntries.html'),
				clickOutsideToClose: false,
			})
		}

		let endStage = () => {
			return $mdDialog.show({
				controller         : 'EndStageModalCtrl',
				controllerAs       : 'endStageModalVm',
				template           : require('./partials/review/summary/modals/endStageModal.html'),
				clickOutsideToClose: false,
			})
		}

		let feedbackReviewed = () => {
			return $mdDialog.show({
				controller         : 'FeedbackReviewedModalCtrl',
				controllerAs       : 'feedbackReviewedModalVm',
				template           : require('./partials/review/summary/modals/feedbackReviewedModal.html'),
				clickOutsideToClose: false,
			})
		}

		let addTeachingActivity = () => {
			return $mdDialog.show({
				controller         : 'CreateActivityCtrl',
				controllerAs       : 'createActivityVm',
				template           : require('./partials/review/modals/addTeachingActivity.html'),
				clickOutsideToClose: false,
			})
		}

		let addAcademicManagementActivity = () => {
			return $mdDialog.show({
				controller         : 'CreateOtherActivityCtrl',
				controllerAs       : 'createActivityVm',
				template           : require('./partials/review/modals/addAcademicManagementActivity.html'),
				clickOutsideToClose: false,
			})
		}

		let addAcademicManagementRole = () => {
			return $mdDialog.show({
				controller         : 'CreateRoleCtrl',
				controllerAs       : 'createRoleVm',
				template           : require('./partials/review/modals/addAcademicManagementRole.html'),
				clickOutsideToClose: false,
			})
		}

		let addAcademicManagementCommitteParticipation = () => {
			return $mdDialog.show({
				controller         : 'CreateParticipationCtrl',
				controllerAs       : 'participationVm',
				template           : require('./partials/review/modals/addAcademicManagementCommitteParticipation.html'),
				clickOutsideToClose: false,
			})
		}

		let itemRequiredTeaching = () => {
			return $mdDialog.show({
				controller         : 'ItemRequiredModalCtrl',
				template           : require('./partials/modals/itemRequiredModal.html'),
				clickOutsideToClose: false,
			})
		}

		let itemRequiredExecution = () => {
			return $mdDialog.show({
				controller         : 'ItemRequiredExecutionModalCtrl',
				template           : require('./partials/modals/itemRequiredExecutionModal.html'),
				clickOutsideToClose: false,
			})
		}

		let setupActivity = (scope, activity) => {
			$mdDialog.show({
				controller: [ '$scope', '$mdDialog', '$state', 'ReviewSrv', function ($scope, $mdDialog, $state, ReviewSrv) {
					$scope.save = () => {
						let header = { id_code: activity.workplanTeacherActivityId }

						ReviewSrv.setactivityTag.set(header).$promise.then((dataReturn) => {
							if (dataReturn.status) {
								$scope.close()
								$state.reload()
							}
						})
					}
					$scope.close = () => {
						scope.cb1 = true
						$mdDialog.hide()
					}
				} ],
				// template: '<div ng-include="setupErrorModal"><div>',
				template           : require('../../../partials/setupErrorModal.html'),
				clickOutsideToClose: false,
			})
		}

		let successDialog = (shared) => {
			return $mdDialog.show({
				controller         : 'SuccessDialogCtrl',
				controllerAs       : 'ctrlModalVM',
				template           : require('./modals/successDialog.html'),
				clickOutsideToClose: false,
				params             : {
					shared: shared,
				},
			})
		}

		let reusableVariable = null
		let reusableVariable2 = null

		function setVariable (variable) {
			reusableVariable = variable

			return reusableVariable
		}

		function getVariable () {
			let unload = reusableVariable

			reusableVariable = null

			return unload
		}

		function setVariableSuccessDialog (variable) {
			reusableVariable2 = variable

			return reusableVariable2
		}

		function getVariableSuccessDialog () {
			let unload = reusableVariable2

			reusableVariable2 = null

			return unload
		}

		let addConsolidationCourseExternal = () => {
			return $mdDialog.show({
				controller         : 'CreateCourseCtrl',
				controllerAs       : 'createCourseVm',
				template           : require('./partials/review/modals/addConsolidationCourseExternal.html'),
				clickOutsideToClose: true,
			})
		}

		let addConsolidationLearningComunity = () => {
			return $mdDialog.show({
				controller         : 'CreateLearningComunityCtrl',
				controllerAs       : 'createLearningComunityVM',
				template           : require('./partials/review/modals/addConsolidationLearningComunity.html'),
				clickOutsideToClose: true,
			})
		}

		let addDoctoralEducation = () => {
			return $mdDialog.show({
				controller         : 'CreateDoctorateCtrl',
				controllerAs       : 'createDoctorateVm',
				template           : require('./partials/review/modals/addDoctoralEducation.html'),
				clickOutsideToClose: true,
			})
		}

		let addConsolidationOfferCourses = () => {
			return $mdDialog.show({
				controller         : 'ReviewTeacherDevelopmentCtrl',
				controllerAs       : 'reviewTVM',
				template           : require('./partials/review/modals/addConsolidationOfferCourses.html'),
				clickOutsideToClose: true,
			})
		}

		let listTransversalProjects = () => {
			return $mdDialog.show({
				controller         : 'listTransversalProjectsCtrl',
				controllerAs       : 'listTPCtrl',
				template           : require('./extensionVisibility/modals/listTransversalProjects.html'),
				clickOutsideToClose: true,
			})
		}

		let addActivityProject = () => {
			return $mdDialog.show({
				controller         : 'CreateProjectCtrl',
				controllerAs       : 'createProjectVm',
				template           : require('./research/projects/createProject/createActivityProjectModal.html'),
				clickOutsideToClose: true,
			})
		}

		let addActivityProduct = () => {
			return $mdDialog.show({
				controller         : 'CreateProductCtrl',
				controllerAs       : 'createProductVm',
				template           : require('./research/products/createProduct/createActivityProductModal.html'),
				clickOutsideToClose: true,
			})
		}

		let viewFile = () => {
			return $mdDialog.show({
				controller         : 'ViewFileCtrl',
				template           : require('./partials/review/modals/viewFile.html'),
				clickOutsideToClose: true,
				preserveScope      : true,
			})
		}

		let addActivityExtensionProject = () => {
			return $mdDialog.show({
				controller         : 'CreateExtensionProjectCtrl',
				controllerAs       : 'createExtensionProjectVm',
				template           : require('./extensionVisibility/extensionProjects/create/createActivityProjectModal.html'),
				clickOutsideToClose: true,
			})
		}

		let addInvestigationProjectsFormulation = () => {
			return $mdDialog.show({
				controller         : 'CreateProjectFormulationCtrl',
				controllerAs       : 'createProjectFormulationVm',
				template           : require('./partials/review/modals/addProjectsFormulation.html'),
				clickOutsideToClose: true,
			})
		}

		let addInvestigationProjects = () => {
			return $mdDialog.show({
				controller         : 'CreateProjectCtrl',
				controllerAs       : 'createProjectVm',
				template           : require('./partials/review/modals/addInvestigationProjects.html'),
				clickOutsideToClose: true,
			})
		}

		let addInvestigationProducts = () => {
			return $mdDialog.show({
				controller         : 'CreateProductCtrl',
				controllerAs       : 'createProductVm',
				template           : require('./partials/review/modals/addInvestigationProducts.html'),
				clickOutsideToClose: true,
			})
		}

		let addInvestigationSpace = () => {
			return $mdDialog.show({
				controller         : 'CreateSpaceCtrl',
				controllerAs       : 'createSpaceVm',
				template           : require('./partials/review/modals/addInvestigationSpace.html'),
				clickOutsideToClose: true,
			})
		}

		let addInvestigationTrainingResearch = () => {
			return $mdDialog.show({
				controller         : 'CreateTrainingResearchCtrl',
				controllerAs       : 'createTrainingVm',
				template           : require('./partials/review/modals/addInvestigationTrainingResearch.html'),
				clickOutsideToClose: true,
			})
		}

		let addInvestigationResultsTransfer = () => {
			return $mdDialog.show({
				controller         : 'CreateResultsTransferCtrl',
				controllerAs       : 'createTransferVm',
				template           : require('./partials/review/modals/addInvestigationResultsTransfer.html'),
				clickOutsideToClose: true,
			})
		}

		let addProjectFormulation = () => {
			return $mdDialog.show({
				controller         : 'CreateProjectFormulationProposalCtrl',
				controllerAs       : 'createProjectFormulationProposalVm',
				template           : require('./partials/review/modals/addProjectFormulation.html'),
				clickOutsideToClose: true,
			})
		}

		let addProjectExtension = () => {
			return $mdDialog.show({
				controller         : 'CreateExtensionProjectCtrl',
				controllerAs       : 'createExtensionProjectVm',
				template           : require('./partials/review/modals/addProjectExtension.html'),
				clickOutsideToClose: true,
			})
		}

		let addVisibility = () => {
			return $mdDialog.show({
				controller         : 'CreateVisibilityCtrl',
				controllerAs       : 'createVisibilityVm',
				template           : require('./partials/review/modals/addVisibility.html'),
				clickOutsideToClose: true,
			})
		}

		let addCounselingAndConsultancy = () => {
			return $mdDialog.show({
				controller         : 'CreateCounselingAndConsultancyCtrl',
				controllerAs       : 'createCounselingAndConsultancyVm',
				template           : require('./partials/review/modals/addCounselingAndConsultancy.html'),
				clickOutsideToClose: true,
			})
		}

		let addEducation = () => {
			return $mdDialog.show({
				controller         : 'CreateShortCoursesCtrl',
				controllerAs       : 'createShortCourseVm',
				template           : require('./partials/review/modals/addEducation.html'),
				clickOutsideToClose: true,
			})
		}

		return {
			endPlanning                               : endPlanning,
			addActivity                               : addActivity,
			registerExecution                         : registerExecution,
			editChildrenExecution                     : editChildrenExecution,
			executionEntries                          : executionEntries,
			endStage                                  : endStage,
			addTeachingActivity                       : addTeachingActivity,
			addAcademicManagementActivity             : addAcademicManagementActivity,
			addAcademicManagementRole                 : addAcademicManagementRole,
			addAcademicManagementCommitteParticipation: addAcademicManagementCommitteParticipation,
			itemRequiredTeaching                      : itemRequiredTeaching,
			addConsolidationCourseExternal            : addConsolidationCourseExternal,
			addConsolidationLearningComunity          : addConsolidationLearningComunity,
			addDoctoralEducation                      : addDoctoralEducation,
			addConsolidationOfferCourses              : addConsolidationOfferCourses,
			listTransversalProjects                   : listTransversalProjects,
			addActivityProject                        : addActivityProject,
			addActivityProduct                        : addActivityProduct,
			viewFile                                  : viewFile,
			feedbackReviewed                          : feedbackReviewed,
			itemRequiredExecution                     : itemRequiredExecution,
			addInvestigationProjectsFormulation       : addInvestigationProjectsFormulation,
			addInvestigationProjects                  : addInvestigationProjects,
			addInvestigationProducts                  : addInvestigationProducts,
			successDialog                             : successDialog,
			addInvestigationSpace                     : addInvestigationSpace,
			addInvestigationTrainingResearch          : addInvestigationTrainingResearch,
			addInvestigationResultsTransfer           : addInvestigationResultsTransfer,
			// extension
			addActivityExtensionProject               : addActivityExtensionProject,
			addProjectFormulation                     : addProjectFormulation,
			addProjectExtension                       : addProjectExtension,
			addVisibility                             : addVisibility,
			addCounselingAndConsultancy               : addCounselingAndConsultancy,
			addEducation                              : addEducation,
			setupActivity                             : setupActivity,
			// open methods
			setVariable                               : setVariable,
			getVariable                               : getVariable,
			getVariableSuccessDialog                  : getVariableSuccessDialog,
			setVariableSuccessDialog                  : setVariableSuccessDialog,

		}
	}

}

WorkPlanModalSrv.$inject = [ '$mdDialog', '$cookies', 'WorkPlanSrv' ]
export default angular.module('services.WorkPlanModalSrv', []).service('WorkPlanModalSrv', WorkPlanModalSrv).name



// WEBPACK FOOTER //
// ./src/app/u-faculty/workplan/workplanModalSrv.js